import TIM from 'tim-js-sdk'

export default class TimClient {
  tim: any
  userID: string
  userSig: string

  constructor(SDKID: number, userID: string, userSig: string) {
    let options = {
      SDKAppID: SDKID
    }
    this.userID = userID
    this.userSig = userSig

    let tim = TIM.create(options)
    tim.setLogLevel(1)

    this.tim = tim
  }

  login() {
    return this.tim.login({ userID: this.userID, userSig: this.userSig })
  }

  addGroup(groupID: string) {
    return this.tim.joinGroup({
      groupID,
      applyMessage: 'apply join room'
    })
  }

  async exitRooms() {
    let imResponse = await this.tim.getGroupList()
    if (imResponse) {
      let names = imResponse.data.groupList.map((val: any) => val.name)
      names.forEach((id: string) => this.tim.quitGroup(id))
    }
  }

  quitGroup(groupID: string) {
    return this.tim.quitGroup(groupID)
  }

  on(eventName: string, callback: Function) {
    this.tim.on(eventName, callback)
  }
}
